import { readStoredCompactViewPreference, writeStoredCompactViewPreference } from "./layoutPolicy";

export function getCompactPreference(): boolean {
  return readStoredCompactViewPreference();
}

export function setCompactPreference(v: boolean) {
  writeStoredCompactViewPreference(v);
}
